import { useState } from 'react';
import { useGetMyProfileQuery, useMarkOnboardingCompleteMutation } from '../../../store/api/usersApi';
import { GustavoOnboarding } from './GustavoOnboarding';

// Roles que usan Gustavo y deberían ver el onboarding. Platform/support/portal quedan fuera.
const ONBOARDING_ROLES = ['agent', 'tenant_agent', 'office_admin', 'tenant_admin'];

/**
 * Muestra el onboarding guiado de Gustavo a los agentes que todavía no pasaron por él.
 * Se gatea por el flag de BASE DE DATOS `hasCompletedOnboarding` (no localStorage), así
 * persiste por usuario en cualquier dispositivo.
 */
export function GustavoOnboardingGate() {
  const { data: profile } = useGetMyProfileQuery();
  const [markComplete] = useMarkOnboardingCompleteMutation();
  const [dismissed, setDismissed] = useState(false);

  const role = (profile as any)?.role as string | undefined;
  const shouldShow = !!profile
    && profile.hasCompletedOnboarding !== true
    && !!role && ONBOARDING_ROLES.includes(role)
    && !dismissed;

  if (!shouldShow) return null;

  const finish = async (openChat: boolean) => {
    setDismissed(true); // saca el overlay ya; la persistencia va en paralelo
    try { await markComplete().unwrap(); } catch { /* si falla, se reintenta en el próximo /me */ }
    if (openChat) {
      // Dejamos cerrar el overlay antes de abrir el chat de Gustavo.
      setTimeout(() => window.dispatchEvent(new CustomEvent('gustavo:open')), 280);
    }
  };

  return <GustavoOnboarding name={(profile as any).name} onFinish={finish} />;
}
